module.exports = {
      id: "quotes-usage",
      viewBox: "0 0 37 25",
      url: __webpack_public_path__ + "sprite-d2a4e8aaeb47684d6d07571fc646b0db.svg#quotes",
      toString: function () {
        return this.url;
      }
    }